import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { Like } from '../../_models/auto_seeding/like';
import { FollowUser } from '../../_models/auto_seeding/followUser';
import { ConfigPermissionOption } from '../../_helpers/config-permission-option';
import { LikePage } from '../../_models/auto_seeding/likePage';
import { Share } from '../../_models/auto_seeding/share';
import { Comment } from '../../_models/auto_seeding/comment';
import { Post } from '../../_models/auto_seeding/post';
import { JoinGroup } from '../../_models/auto_seeding/join_group';
import { SeedingPost } from '../../_models/auto_seeding/seeding_post';
import { SeedingComment } from '../../_models/auto_seeding/seeding_comment';
import { Interactive } from '../../_models/auto_seeding/interactive';
import { AutoseedingService } from '../../_services/autoseeding.service';
import * as io from 'socket.io-client';
import { ServiceConfig } from 'app/_services/service-config';
import { BsModalService } from 'ngx-bootstrap';
import { LikeComment } from 'app/_models/auto_seeding/likeComment';
import { Router } from '@angular/router';
import { GlobalService } from 'app/_services/global.service';
const moment = require('moment');
@Component({
  selector: 'auto-seeding',
  templateUrl: './auto-seeding.component.html',
  styleUrls: ['./auto-seeding.component.scss'],
  providers: [AutoseedingService]
})
export class AutoSeedingComponent implements OnInit {
  @ViewChild('baseLineChart') baseLineChart: BaseChartDirective;
  tab = 1;
  socket: SocketIOClient.Socket;
  private host = ServiceConfig.host_socket;
  file: any;
  //Các loại chiến dịch (hành động)
  actionSeedingDropDownSettings = {
    singleSelection: true,
    text: 'Chọn chiến dịch',
    selectAllText: 'Chọn tất cả',
    unSelectAllText: 'Bỏ chọn tất cả',
    enableSearchFilter: false,
    badgeShowLimit: 1,
  };

  histotyCampainDropDownSettings = {
    singleSelection: false,
    text: 'Chọn chiến dịch',
    selectAllText: 'Chọn tất cả',
    unSelectAllText: 'Bỏ chọn tất cả',
    enableSearchFilter: false,
    badgeShowLimit: 1,
  };
  // config chọn nhóm tài khoản
  configSelectGroupAccount = {
    singleSelection: false,
    text: 'Chọn nhóm tài khoản ',
    selectAllText: 'Chọn tất cả',
    unSelectAllText: 'Bỏ chọn tất cả',
    enableSearchFilter: false,
    badgeShowLimit: 2,
  };

  modalRef: BsModalRef;
  public autoSeedings: Array<any>;
  public like: Like;
  public likeComment: LikeComment;

  public followUser: FollowUser;
  public likePage: LikePage;

  groups = '';
  groups2 = '';
  answers_join_group = '';
  comments = '';
  accountJoinCampain = 1;
  name_campain = '';
  check_name_campain = false;
  show_action_seeding = false;

  sugggetComment = 0;

  actionSeedings = [
    {
      id: "LIKE_PAGE",
      itemName: "Like page",
      value: "Like page"
    },
    {
      id: "FOLLOW_USER",
      itemName: "Follow User",
      value: "Follow User"
    },
    {
      id: "LIKE_POST",
      itemName: "Like bài viết",
      value: "Like bài viết"
    },
    {
      id: "LIKE_COMMENT",
      itemName: "Like bình luận",
      value: "Like bình luận"
    },
    {
      id: "SHARE",
      itemName: "Share",
      value: "Share"
    },
    {
      id: "COMMENT_POST",
      itemName: "Bình Luận bài viết",
      value: "Bình luận bài viết"
    },
    // {
    //   id: "COMMENT_COMMENT",
    //   itemName: "Trả lời bình luận",
    //   value: "Trả lời bình luận"
    // },
    {
      id: "POST",
      itemName: "Đăng Bài",
      value: "Đăng Bài"
    },
    {
      id: "JOIN_GROUP",
      itemName: "Tham gia nhóm",
      value: "Tham gia nhóm"
    },
    {
      id: "DYNAMIC_SCRIPT",
      itemName: "Kịch bản động",
      value: "Kịch bản động"
    }
  ];

  actionSeedingSelected = [];
  historyCampainSelected = [];

  //cac loai kich ban dong
  dynamicScriptDropDownSettings = {
    singleSelection: true,
    text: 'Chọn kịch bản',
    selectAllText: 'Chọn tất cả',
    unSelectAllText: 'Bỏ chọn tất cả',
    enableSearchFilter: false,
    badgeShowLimit: 1,
  };

  dynamicScripts = [
    {
      id: "POST",
      itemName: "Tăng tương tác bài viết",
      value: "Tăng tương tác bài viết"
    },
    // {
    //   id: "COMMENT",
    //   itemName: "Tăng tương tác bình luận",
    //   value: "Tăng tương tác bình luận"
    // },
    {
      id: "VIA",
      itemName: "Chạy tương tác tài khoản",
      value: "Chạy tương tác tài khoản"
    }
  ];

  dynamicScriptSelected = [];

  // cảm xúc like bài viết
  reaction = {
    Like: false,
    Love: false,
    Care: false,
    Haha: false,
    Wow: false,
    Sad: false,
    Angry: false
  }
  translate = {
    Like: 'Thích',
    Love: 'Yêu thích',
    Care: 'Thương thương',
    Haha: 'Haha',
    Wow: 'Wow',
    Sad: 'Buồn',
    Angry: 'Phẫn nộ'
  }
  // id group cần share
  id_group_share_textarea;
  typeSeeding = '';
  currentDeleteIdConfig = '';
  detailUsers = [];
  detailConfigs = [];
  detailUsersCurrentSeeding = [];
  // chọn nhóm tài khoản
  groupAccount = [
    {
      id: "AUTOVIAVIET",
      itemName: "autoviaviet",
      value: "autoviaviet"
    },
    {
      id: "AUTOCLONE",
      itemName: "autoclone",
      value: "autoclone"
    },
    {
      id: "SEEDINGVINA",
      itemName: "seedingvina",
      value: "seedingvina"
    }
  ];
  translateConfig = {
    type: 'Kiểu chiến dịch',
    time_before_seeding: 'Thời gian delay trước khi seeding',
    time_after_content: 'Thời gian delay sau khi điền nội dung',
    time_after_seeding: 'Thời gian delay sau khi seeding',
    reaction: 'Cảm xúc',
    is_share_personal: 'Share trang cá nhân?',
    content: 'Nội dung',
    is_post_personal: 'Đăng bài lên trang cá nhân?',
    groups: 'Danh sách nhóm',
    maxPostGroup: 'Số nhóm tối đa 1 tài khoản được đăng bài',
    is_join_1_group: 'Cho phép nhiều tài khoản cùng tham gia 1 nhóm',
    maxShareGroup: 'Số nhóm tối đa 1 tài khoản được share bài',
  }

  groupAccountSelected = Array();
  public share: Share;
  public comment: Comment;
  public replyComment: Comment;
  public post: Post;
  public join_group: JoinGroup;
  public seeding_post: SeedingPost;
  public seeding_comment: SeedingComment;
  public interactive: Interactive;

  public daterange: any = {
    start: moment().subtract(7, "days").startOf('day'),
    end: moment().endOf('day')
  };

  dtOptions = {
    pagingType: 'full_numbers',
    ordering: false,
    searching: true,
    paging: true,
    language: {
      infoEmpty: 'Không tìm thấy dữ liệu',
      infoFiltered: '(trong _MAX_ )',
      info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
      lengthMenu: 'Hiển thị _MENU_ ',
      search: 'Tìm kiếm',
      zeroRecords: 'Không có dữ liệu !',
      paginate: {
        first: '<<',
        previous: '<',
        next: '>',
        last: '>>',
      }
    },
    columnDefs: [
      { 'targets': [0, 1, 2, 3, 4, 5], 'searchable': true }
    ]
  };
  optionsTime: any = {
    locale: { format: 'DD/MM/YYYY HH:mm:ss' },
    timePicker: true,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().endOf('day').toDate(),
    startDate: this.daterange.start,
    endDate: this.daterange.end
  };

  campainsHistory = [];
  currentRunning = null;
  currentAccount = null;

  showEditTime = false;
  public configPermissionOption = ConfigPermissionOption;
  constructor(
    private toastrService: ToastrService,
    private modalService: BsModalService,
    private globalService: GlobalService,
    private router: Router,
    private autoseedingService: AutoseedingService) {
    this.showEditTime = this.globalService.canPermission(this.configPermissionOption.showEditTime);


    this.currentAccount = localStorage.getItem('currentSmmAccount') ? JSON.parse(localStorage.getItem('currentSmmAccount')) : {};
    console.log(this.currentAccount)
    this.like = new Like();
    this.likeComment = new LikeComment();
    this.likePage = new LikePage();
    this.followUser = new FollowUser();
    this.share = new Share();
    this.comment = new Comment();
    this.replyComment = new Comment();
    this.post = new Post();
    this.join_group = new JoinGroup();
    this.seeding_post = new SeedingPost();
    this.seeding_comment = new SeedingComment();
    this.interactive = new Interactive();
    this.socket = io.connect(this.host, { path: '/api/socket.io' });
    this.socket.on('auto-seeding-channel', (configItem: any) => {
      if (this.currentAccount && this.currentAccount.username == configItem.message.created_by) {
        // for current seeding
        this.currentRunning = configItem.message;
        this.getDetailCurrentRunning(configItem.message._id);
        // end for current seeding
      }
      this.campainsHistory.forEach((element, index) => {
        if (element._id === configItem.message._id) {
          this.campainsHistory[index] = configItem.message;
        }
      });

    });
    console.log(this.router.url);
    this.initActionSeeding(this.router.url);
  }

  initActionSeeding(routerUrl) {
    if (routerUrl == '/auto-seeding') {
      this.show_action_seeding = true;
    }

    if (routerUrl == '/auto-like-page') {
      this.actionSeedingSelected = this.historyCampainSelected =  [
        {
          id: "LIKE_PAGE",
          itemName: "Like page",
          value: "Like page"
        }
      ]
    }
    if (routerUrl == '/auto-follow-user') {
      this.actionSeedingSelected = this.historyCampainSelected = [
       {
          id: "FOLLOW_USER",
          itemName: "Follow User",
          value: "Follow User"
        }
      ]
    }
    if (routerUrl == '/auto-like-post') {
      this.actionSeedingSelected = this.historyCampainSelected = [
          {
          id: "LIKE_POST",
          itemName: "Like bài viết",
          value: "Like bài viết"
        }
      ]
    }
    if (routerUrl == '/auto-like-comment') {
      this.actionSeedingSelected = this.historyCampainSelected = [
         {
          id: "LIKE_COMMENT",
          itemName: "Like bình luận",
          value: "Like bình luận"
        }
      ]
    }
    if (routerUrl == '/auto-share') {
      this.actionSeedingSelected = this.historyCampainSelected = [
         {
          id: "SHARE",
          itemName: "Share",
          value: "Share"
        }
      ]
    }
    if (routerUrl == '/auto-comment') {
      this.actionSeedingSelected = this.historyCampainSelected =[
        {
          id: "COMMENT_POST",
          itemName: "Bình Luận bài viết",
          value: "Bình luận bài viết"
        }
      ]
    }
    if (routerUrl == '/auto-post') {
      this.actionSeedingSelected = this.historyCampainSelected =[
        {
          id: "POST",
          itemName: "Đăng Bài",
          value: "Đăng Bài"
        }
      ]
    }
    if (routerUrl == '/auto-join-group') {
      this.actionSeedingSelected = this.historyCampainSelected = [
        {
        id: "JOIN_GROUP",
        itemName: "Tham gia nhóm",
        value: "Tham gia nhóm"
        }
      ]
    }
    if (routerUrl == '/auto-dynamic-script') {
      this.actionSeedingSelected = this.historyCampainSelected = [
        {
        id: "DYNAMIC_SCRIPT",
        itemName: "Kịch bản động",
        value: "Kịch bản động"
        }
      ]
    }
  }

  checkAccountJoinCampain() {
    if (0 < this.accountJoinCampain && this.accountJoinCampain <= 3000) {
      return true;
    }
    return false;
  }

  validateComment() {
    let comments =  this.comments.split('\n');
    let uniqueComments =  new Set(comments);
    if(( Array.from(uniqueComments).length / comments.length) < 0.7) {
      this.sugggetComment = Math.ceil((0.7 * comments.length) - Array.from(uniqueComments).length);
      return false;
    } else {
      this.sugggetComment = 0;
    }
    return true;
  }

  resetValueCheckbox(key) {
    for (var _key in this.reaction) {
      if (_key !== key) {
        this.reaction[_key] = false;
      }
    }
  }

  ngOnInit(): void {

    this.getAllTypeAccount()
  };

  getAllTypeAccount() {
    this.autoseedingService.getAllTypeAccount().subscribe(res => {
      if (res && res.data && res.data.typeAccounts) {
        this.groupAccount = []
        for (let item in res.data.typeAccounts) {
          this.groupAccount.push({
            id: res.data.typeAccounts[item]._id.toUpperCase(),
            itemName: res.data.typeAccounts[item]._id.toLowerCase() + ` (${res.data.typeAccounts[item].count})`,
            value: res.data.typeAccounts[item]._id.toLowerCase()
          })
        }
      }
    })
  }

  closeModal() {
    this.modalRef.hide();
  }
  stopConfig(_idx, configId) {
    this.autoseedingService.stopConfig({ configId: configId }).subscribe(res => {
      if (res.success) {
        this.campainsHistory[_idx]['status'] = 'STOP';
        this.toastrService.success(res.msg, 'Thông báo')

      } else {
        this.toastrService.warning(res.msg, 'Thông báo')
      }
    })
  }

  resumeConfig(_idx, configId) {
    this.autoseedingService.resumeConfig({ configId: configId }).subscribe(res => {
      if (res.success) {
        this.campainsHistory[_idx]['status'] = 'RUNNING';
        this.toastrService.success(res.msg, 'Thông báo')

      } else {
        this.toastrService.warning(res.msg, 'Thông báo')
      }
    })
  }


  startConfig(_idx, configId) {
    this.autoseedingService.startConfig({ _id: configId }).subscribe(res => {
      if (res.success) {
        this.campainsHistory[_idx]['status'] = 'RUNNING';
        this.toastrService.success(res.msg, 'Thông báo')

      } else {
        this.toastrService.warning(res.msg, 'Thông báo')
      }
    })
  }

  getAllConfigs() {
    this.campainsHistory = [];
    let body = {
      min_created_time: this.daterange.start.valueOf(),
      max_created_time: this.daterange.end.valueOf(),
      types: this.historyCampainSelected.map(e => e.id)
    }
    this.autoseedingService.getAllConfigs(body).subscribe(res => {
      if (res.success) {
        this.campainsHistory = res.data;
      } else {
        this.toastrService.error(res.msg, 'Thông báo');
      }
    },
      err => {
        this.toastrService.error('Có lỗi xảy ra!', 'Lỗi');
      });
  }
  getDetailCurrentRunning(configId) {
    this.autoseedingService.getDetail({ configId: configId }).subscribe(res => {
      if (res.success) {
        const results = this.mappingDataDetail(res.data);
        this.detailUsersCurrentSeeding = results.reverse();
      }
    });
  }

  fileChanged(e, type = 'group') {
    this.file = e.target.files[0];
    console.log(this.file)
    let fileReader = new FileReader();
    fileReader.onload = (e) => {
      if (type == 'group') {
        this.groups = e.target.result.toString();
      }
      if (type == 'comment') {
        this.comments = e.target.result.toString();
      }
      if (type == 'answers') {
        this.answers_join_group = e.target.result.toString();
      }
    }
    fileReader.readAsText(this.file);
  }


  showDetail(item, modalRef) {
    this.detailUsers = [];
    this.typeSeeding = item.type;
    this.autoseedingService.getDetail({ configId: item._id }).subscribe(res => {
      if (res.success) {
        this.detailUsers = this.mappingDataDetail(res.data);
      }
    });
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }

  showConfig(item, modalRef) {
    this.detailConfigs = this.mappingConfig(item.configs);
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'modal-md'
    });
  }
  mappingConfig(configs) {
    let results = [];
    for (let index = 0; index < configs.length; index++) {
      const config = configs[index];
      let configItem = {
        name: config.type,
        config: []
      }
      for (var _key in config) {
        configItem.config.push({
          type: this.translateConfig[_key] ? this.translateConfig[_key] : _key,
          value: _key !== 'reaction' ? config[_key] : config[_key][0].vi
        })
      }
      results.push(configItem)
    }

    return results;
  }
  showPopupDelete(item, modalRef) {
    this.currentDeleteIdConfig = item._id;
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'modal-md'
    });
  }
  deleteCofig() {
    this.autoseedingService.deleteConfig(this.currentDeleteIdConfig).subscribe(res => {
      if (res.success) {
        this.toastrService.success("Xóa thành công cấu hình", 'Thông báo');
        this.modalRef.hide();
        this.getAllConfigs();
      } else {
        this.toastrService.error('Xóa thất bại', 'Thông báo');
      }
    })
  }
  mappingDataDetail(data) {
    let result = [];
    for (let index = 0; index < data.length; index++) {
      const itemDetail = data[index];

      const userId = itemDetail.userId;
      const userName = itemDetail.userName ;
      const created_at = itemDetail.created_at;


      let targetLink = itemDetail.result.targetLink || '-';
      let response = 'Thất bại';
      let reason = '';
      let content = itemDetail.result.text || '-';
 

      if (itemDetail.result.LIKE_POST) {
        if(itemDetail.result.LIKE_POST.success) {
          response = 'Thành công';
        }
        if(itemDetail.result.LIKE_POST.msg){
          reason = itemDetail.result.LIKE_POST.msg;
        }
        result.push({
          userId: userId,
          targetLink: targetLink,
          response: response,
          userName: userName,
          content: content,
          reason: reason,
          created_at: created_at
        });
      }
      if (itemDetail.result.LIKE_PAGE ) {
        if(itemDetail.result.LIKE_PAGE.success) {
          response = 'Thành công';
        }
        if (itemDetail.result.LIKE_PAGE.msg) {
          reason = itemDetail.result.LIKE_PAGE.msg;
        }
        result.push({
          userId: userId,
          targetLink: targetLink,
          response: response,
          content: content,
          userName: userName,
          reason: reason,
          created_at: created_at
        });
      }
      if (itemDetail.result.FOLLOW_USER) {
        if(itemDetail.result.FOLLOW_USER.success) {
          response = 'Thành công';
        }
        if (itemDetail.result.FOLLOW_USER.msg) {
          reason = itemDetail.result.FOLLOW_USER.msg;
        }
        result.push({
          userId: userId,
          targetLink: targetLink,
          response: response,
          userName: userName,
          content: content,
          reason: reason,
          created_at: created_at
        });
      }
      if (itemDetail.result.LIKE_COMMENT) {
        if(itemDetail.result.LIKE_COMMENT.success) {
          response = 'Thành công';
        }
        if (itemDetail.result.LIKE_COMMENT.msg) {
          reason = itemDetail.result.LIKE_COMMENT.msg;
        }
        result.push({
          userId: userId,
          targetLink: targetLink,
          userName : userName,
          response: response,
          content: content,
          reason: reason,
          created_at: created_at
        });
      }
      if (itemDetail.result.COMMENT_POST ) {
        if(itemDetail.result.COMMENT_POST.success) {
          response = 'Thành công';
        }
        if (itemDetail.result.COMMENT_POST.msg) {
          reason = itemDetail.result.COMMENT_POST.msg;
        }
        result.push({
          userId: userId,
          targetLink: targetLink,
          userName : userName,
          response: response,
          content: itemDetail.result.COMMENT_POST.content ? itemDetail.result.COMMENT_POST.content : content,
          reason: reason,
          created_at: created_at
        });
      }
      if (itemDetail.result.SHARE) {
        if (itemDetail.result.SHARE.success) {
          if (itemDetail.result.SHARE.personal && itemDetail.result.SHARE.personal.status) {
            result.push({
              userId: userId,
              userName : userName,
              targetLink: targetLink,
              response: itemDetail.result.SHARE.personal.result.success ? `Share thành công lên trang cá nhân ${userId}` : 'Không thành công',
              content: itemDetail.result.SHARE.content ? itemDetail.result.SHARE.content : content,
              reason: itemDetail.result.SHARE.personal.result.msg,
              created_at: created_at
            });
          }
          if (itemDetail.result.SHARE.groups && itemDetail.result.SHARE.groups.groupIds) {
            for (var _groupId in itemDetail.result.SHARE.groups.groupIds) {
              result.push({
                userId: userId,
                userName: userName,
                created_at: created_at,
                targetLink: targetLink,
                response: itemDetail.result.SHARE.groups.groupIds[_groupId].success ? `Share thành công vào nhóm ${_groupId}` : 'Thất bại',
                content: itemDetail.result.SHARE.content ? itemDetail.result.SHARE.content : content,
                reason: itemDetail.result.SHARE.groups.groupIds[_groupId].msg
              });
            }
          }
        } else {
          result.push({
            userId: userId,
            userName :userName,
            targetLink: targetLink,
            response: 'Thất bại',
            content: content,
            reason: 'Tài khoản trên hệ thống đã bị chết',
          });
        }
      }
      if (itemDetail.result.JOIN_GROUP) {
        if (itemDetail.result.JOIN_GROUP.success) {
          // if(itemDetail.result.JOIN_GROUP.groups && !itemDetail.result.JOIN_GROUP.groups.status) {
          //   result.push({
          //     userId :userId,
          //     targetLink: targetLink,
          //     response : 'Thất bại',
          //     content : content,
          //     reason : 'Tài khoản chưa được chia nhóm cần join',
          //     created_at : created_at
          //   });
          // }
          if (itemDetail.result.JOIN_GROUP.groups && itemDetail.result.JOIN_GROUP.groups.groupIds) {
            for (var _groupId in itemDetail.result.JOIN_GROUP.groups.groupIds) {
              result.push({
                userId: userId,
                targetLink: targetLink,
                userName : userName,
                response: itemDetail.result.JOIN_GROUP.groups.groupIds[_groupId].success ? `Join thành công vào nhóm ${_groupId}` : `Thất bại khi join vào nhóm ${_groupId}`,
                content: content,
                reason: itemDetail.result.JOIN_GROUP.groups.groupIds[_groupId].msg,
                created_at: created_at
              });
            }
          }
          if (itemDetail.result.JOIN_GROUP.groups && itemDetail.result.JOIN_GROUP.groups.joined_groups) {
            for (let _idx in itemDetail.result.JOIN_GROUP.groups.joined_groups) {
              result.push({
                userId: userId,
                targetLink: targetLink,
                userName : userName,
                response: `Thành công`,
                content: content,
                reason: `Tài khoản đã từng được tham gia thành công vào nhóm ${itemDetail.result.JOIN_GROUP.groups.joined_groups[_idx]}`,
                created_at: created_at
              });
            }
          }
        } else {
          result.push({
            userId: userId,
            userName : userName,
            targetLink: targetLink,
            response: 'Thất bại',
            content: content,
            reason: 'Tài khoản trên hệ thống đã bị chết',
          });
        }
      }
      if (itemDetail.result.POST) {
        if (itemDetail.result.POST.success) {
          if (itemDetail.result.POST.personal && itemDetail.result.POST.personal.status) {
            result.push({
              userId: userId,
              userName : userName,
              targetLink: targetLink,
              response: itemDetail.result.POST.personal.result.success ? `Post thành công lên trang cá nhân ${userId}` : 'Không thành công',
              content: itemDetail.result.POST.content ? itemDetail.result.POST.content : content,
              reason: itemDetail.result.POST.personal.result.msg,
              created_at: created_at
            });
          }
          if (itemDetail.result.POST.groups && itemDetail.result.POST.groups.groupIds) {
            for (var _groupId in itemDetail.result.POST.groups.groupIds) {
              result.push({
                userId: userId,
                userName : userName,
                targetLink: targetLink,
                created_at : created_at,
                response: itemDetail.result.POST.groups.groupIds[_groupId].success ? `Post thành công vào nhóm ${_groupId}` : 'Thất bại',
                content: itemDetail.result.POST.content ? itemDetail.result.POST.content : content,
                reason: itemDetail.result.POST.groups.groupIds[_groupId].msg
              });
            }
          }
        } else {
          result.push({
            userId: userId,
            userName : userName,
            targetLink: targetLink,
            created_at : created_at,
            response: 'Thất bại',
            content: itemDetail.result.POST.content ? itemDetail.result.POST.content : content,
            reason: 'Tài khoản trên hệ thống đã bị chết',
          });
        }
      }
    }
    return result;
  }

  public selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start;
    datepicker.end = value.end;
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    this.daterange.label = value.label;
  }

  checkLinkFacebook(link) {
    const pattern = /^(https?:\/\/)?((w{3}\.)?)facebook.com\/.*/;
    if (pattern.test(link)) {
      return true;
    }
    return false;
  }
  checkLinkCommentFacebook(link) {
    if (link.includes('comment_id=')) {
      return true;
    }
    return false;
  }

  checkTimeDelay(min, max) {
    let result = true;
    if (min >= max || Number(max) > 600 || min < 0 || max < 0) {
      result = false;
    }
    return result;
  }

  checkMaxGroup(value) {
    if (value > 0 && value <= 20) {
      return true;
    }
    return false;
  }

  checkGroupList() {
    let validate = true;
    if (this.groups) {
      const list = this.groups.split('\n')
      for (let index = 0; index < list.length; index++) {
        const groupId = list[index];
        const pattern = /([0-9]{9,})\w+/;
        if (!pattern.test(groupId)) {
          return false;
        }
      }
    }
    return validate;
  }
  checkGroupList2() {
    let validate = true;
    if (this.groups2) {
      const list = this.groups2.split('\n')
      for (let index = 0; index < list.length; index++) {
        const groupId = list[index];
        const pattern = /([0-9]{9,})\w+/;
        if (!pattern.test(groupId)) {
          return false;
        }
      }
    }
    return validate;
  }

  createLikeCampain(runOrCreate = 'CREATE') {
    let groupAccounts = this.groupAccountSelected.map(a => a.value);
    let reactions = [];
    for (var _key in this.reaction) {
      if (this.reaction[_key]) {
        reactions.push({
          vi: this.translate[_key],
          en: _key
        });
      }
    }
    if (
      !this.checkAccountJoinCampain() ||
      !this.name_campain ||
      !(reactions.length == 1) ||
      !this.checkTimeDelay(this.like.time_before_seeding_from, this.like.time_before_seeding_to) ||
      !this.checkTimeDelay(this.like.time_after_seeding_from, this.like.time_after_seeding_to) ||
      !this.checkLinkFacebook(this.like.target_link)
    ) {
      this.toastrService.warning('Vui lòng điền chính xác các thông tin của chiến dịch', 'Thông báo');
      return;
    }

    const likeConfig = {
      target_link: this.like.target_link,
      type: 'LIKE_POST',
      accountJoinCampain: this.accountJoinCampain,
      name_campain: this.name_campain,
      configs: [
        {
          type: 'LIKE_POST',
          reaction: reactions,
          time_before_seeding: `${this.like.time_before_seeding_from}-${this.like.time_before_seeding_to}`,
          time_after_seeding: `${this.like.time_after_seeding_from}-${this.like.time_after_seeding_to}`
        }
      ]
    }
    likeConfig['typeAccount'] = groupAccounts;
    // console.log("likeConfig : ", likeConfig)
    this.autoseedingService.create(likeConfig, runOrCreate).subscribe(response => {
      if (response.success) {
        this.resetForm();
        this.toastrService.success('Thực hiện thành công!', 'Thông báo');
      } else {
        this.toastrService.warning(response.msg, 'Thông báo');
      }
    },
      err => {
        this.toastrService.error('Có lỗi xảy ra!', 'Lỗi');
      });
  }
  createLikePageCampain(runOrCreate = 'CREATE') {
    let groupAccounts = this.groupAccountSelected.map(a => a.value);

    if (
      !this.checkAccountJoinCampain() ||
      !this.name_campain ||
      !this.checkTimeDelay(this.likePage.time_before_seeding_from, this.likePage.time_before_seeding_to) ||
      !this.checkTimeDelay(this.likePage.time_after_seeding_from, this.likePage.time_after_seeding_to) ||
      !this.checkLinkFacebook(this.likePage.target_link)
    ) {
      this.toastrService.warning('Vui lòng điền chính xác các thông tin của chiến dịch', 'Thông báo');
      return;
    }

    const likePageConfig = {
      target_link: this.likePage.target_link,
      type: 'LIKE_PAGE',
      accountJoinCampain: this.accountJoinCampain,
      name_campain: this.name_campain,
      configs: [
        {
          type: 'LIKE_PAGE',
          time_before_seeding: `${this.likePage.time_before_seeding_from}-${this.likePage.time_before_seeding_to}`,
          time_after_seeding: `${this.likePage.time_after_seeding_from}-${this.likePage.time_after_seeding_to}`
        }
      ]
    }

    likePageConfig['typeAccount'] = groupAccounts;
    this.autoseedingService.create(likePageConfig, runOrCreate).subscribe(response => {
      if (response.success) {
        this.resetForm();
        this.toastrService.success('Thực hiện thành công!', 'Thông báo');
      } else {
        this.toastrService.warning(response.msg, 'Thông báo');
      }
    },
      err => {
        this.toastrService.error('Có lỗi xảy ra!', 'Lỗi');
      });
  }
  createFollowUserCampain(runOrCreate = 'CREATE') {
    let groupAccounts = this.groupAccountSelected.map(a => a.value);

    if (
      !this.checkAccountJoinCampain() ||
      !this.name_campain ||
      !this.checkTimeDelay(this.followUser.time_before_seeding_from, this.followUser.time_before_seeding_to) ||
      !this.checkTimeDelay(this.followUser.time_after_seeding_from, this.followUser.time_after_seeding_to) ||
      !this.checkLinkFacebook(this.followUser.target_link)
    ) {
      this.toastrService.warning('Vui lòng điền chính xác các thông tin của chiến dịch', 'Thông báo');
      return;
    }

    const followUserConfig = {
      target_link: this.followUser.target_link,
      type: 'FOLLOW_USER',
      accountJoinCampain: this.accountJoinCampain,
      name_campain: this.name_campain,
      configs: [
        {
          type: 'FOLLOW_USER',
          time_before_seeding: `${this.followUser.time_before_seeding_from}-${this.followUser.time_before_seeding_to}`,
          time_after_seeding: `${this.followUser.time_after_seeding_from}-${this.followUser.time_after_seeding_to}`
        }
      ]
    }

    followUserConfig['typeAccount'] = groupAccounts;
    this.autoseedingService.create(followUserConfig, runOrCreate).subscribe(response => {
      if (response.success) {
        this.resetForm();
        this.toastrService.success('Thực hiện thành công!', 'Thông báo');
      } else {
        this.toastrService.warning(response.msg, 'Thông báo');
      }
    },
      err => {
        this.toastrService.error('Có lỗi xảy ra!', 'Lỗi');
      });
  }

  createLikeCommentCampain(runOrCreate = 'CREATE') {
    let groupAccounts = this.groupAccountSelected.map(a => a.value);
    let reactions = [];
    for (var _key in this.reaction) {
      if (this.reaction[_key]) {
        reactions.push({
          vi: this.translate[_key],
          en: _key
        });
      }
    }
    if (
      !this.checkAccountJoinCampain() ||
      !this.name_campain ||
      !(reactions.length == 1) ||
      !this.checkTimeDelay(this.likeComment.time_before_seeding_from, this.likeComment.time_before_seeding_to) ||
      !this.checkTimeDelay(this.likeComment.time_after_seeding_from, this.likeComment.time_after_seeding_to) ||
      !this.checkLinkFacebook(this.likeComment.target_link)
    ) {
      this.toastrService.warning('Vui lòng điền chính xác các thông tin của chiến dịch', 'Thông báo');
      return;
    }

    const likeConfig = {
      target_link: this.likeComment.target_link,
      type: 'LIKE_COMMENT',
      accountJoinCampain: this.accountJoinCampain,
      name_campain: this.name_campain,
      configs: [
        {
          type: 'LIKE_COMMENT',
          reaction: reactions,
          time_before_seeding: `${this.likeComment.time_before_seeding_from}-${this.likeComment.time_before_seeding_to}`,
          time_after_seeding: `${this.likeComment.time_after_seeding_from}-${this.likeComment.time_after_seeding_to}`
        }
      ]
    }
    likeConfig['typeAccount'] = groupAccounts;
    // console.log("likeConfig : ", likeConfig)
    this.autoseedingService.create(likeConfig, runOrCreate).subscribe(response => {
      if (response.success) {
        this.resetForm();
        this.toastrService.success('Thực hiện thành công!', 'Thông báo');
      } else {
        this.toastrService.warning(response.msg, 'Thông báo');
      }
    },
      err => {
        this.toastrService.error('Có lỗi xảy ra!', 'Lỗi');
      });
  }

  createShareCampain(runOrCreate = 'CREATE') {
    let groupAccounts = this.groupAccountSelected.map(a => a.value);
    if (
      !this.checkAccountJoinCampain() ||
      !this.name_campain ||
      !this.checkTimeDelay(this.share.time_before_seeding_from, this.share.time_before_seeding_to) ||
      !this.checkTimeDelay(this.share.time_after_content_from, this.share.time_after_content_to) ||
      !this.checkTimeDelay(this.share.time_after_seeding_from, this.share.time_after_seeding_to) ||
      !this.checkLinkFacebook(this.share.target_link)
    ) {
      this.toastrService.warning('Vui lòng điền chính xác các thông tin của chiến dịch', 'Thông báo');
      return;
    }
    let objShare = {
      target_link: this.share.target_link,
      accountJoinCampain: this.accountJoinCampain,
      name_campain: this.name_campain,
      type: "SHARE",
      configs: [
        {
          type: "SHARE",
          is_share_personal: this.share.is_share_personal,
          content: this.share.content,
          groups: this.groups ? this.groups.split('\n'): [],
          maxShareGroup: this.share.max_group,
          time_before_seeding: "" + this.share.time_before_seeding_from + "-" + this.share.time_before_seeding_to,
          time_after_content: "" + this.share.time_after_content_from + "-" + this.share.time_after_content_to,
          time_after_seeding: "" + this.share.time_after_seeding_from + "-" + this.share.time_after_seeding_to
        }
      ]
    }
    objShare['typeAccount'] = groupAccounts;
    this.autoseedingService.create(objShare, runOrCreate).subscribe(response => {
      if (response.success) {
        this.resetForm();
        this.toastrService.success('Tạo cấu hình thành công!', 'Thông báo');
      } else {
        this.toastrService.warning(response.msg, 'Thông báo');
      }
    },
      err => {
        this.toastrService.error('Có lỗi xảy ra!', 'Lỗi');
      });
  }

  createJoinGroupCampain(runOrCreate = 'CREATE') {
    let groupAccounts = this.groupAccountSelected.map(a => a.value);
    if (
      !this.checkAccountJoinCampain() ||
      !this.name_campain ||
      !this.checkTimeDelay(this.join_group.time_before_seeding_from, this.join_group.time_before_seeding_to) ||
      !this.checkTimeDelay(this.join_group.time_after_content_from, this.join_group.time_after_content_to) ||
      !this.checkTimeDelay(this.join_group.time_after_seeding_from, this.join_group.time_after_seeding_to) ||
      !this.checkGroupList() ||
      !this.checkMaxGroup(this.join_group.max_group)
    ) {
      this.toastrService.warning('Vui lòng điền chính xác các thông tin của chiến dịch', 'Thông báo');
      return;
    }
    let objJoinGroup = {
      type: "JOIN_GROUP",
      accountJoinCampain: this.accountJoinCampain,
      name_campain: this.name_campain,
      configs: [
        {
          max_group: this.join_group.max_group,
          type: "JOIN_GROUP",
          groups: this.groups ? this.groups.split('\n'): [],
          content_replys: this.answers_join_group.split('\n'),
          is_join_1_group: this.join_group.is_join_1_group,
          time_before_seeding: "" + this.join_group.time_before_seeding_from + "-" + this.join_group.time_before_seeding_to,
          time_after_content: "" + this.join_group.time_after_content_from + "-" + this.join_group.time_after_content_to,
          time_after_seeding: "" + this.join_group.time_after_seeding_from + "-" + this.join_group.time_after_seeding_to
        }
      ]
    }
    objJoinGroup['typeAccount'] = groupAccounts;
    this.autoseedingService.create(objJoinGroup, runOrCreate).subscribe(response => {
      if (response.success) {
        this.resetForm();
        this.toastrService.success('Tạo cấu hình thành công!', 'Thông báo');
      } else {
        this.toastrService.warning(response.msg, 'Thông báo');
      }
    },
      err => {
        this.toastrService.error('Có lỗi xảy ra!', 'Lỗi');
      });
  }

  createCommentPostCampain(runOrCreate = 'CREATE') {
    let groupAccounts = this.groupAccountSelected.map(a => a.value);
    if (
      !this.checkAccountJoinCampain() ||
      !this.name_campain ||
      !this.comments ||
      !this.checkTimeDelay(this.comment.time_before_seeding_from, this.comment.time_before_seeding_to) ||
      !this.checkTimeDelay(this.comment.time_after_content_from, this.comment.time_after_content_to) ||
      !this.checkTimeDelay(this.comment.time_after_seeding_from, this.comment.time_after_seeding_to) ||
      !this.checkLinkFacebook(this.comment.target_link)
    ) {
      this.toastrService.warning('Vui lòng điền chính xác các thông tin của chiến dịch', 'Thông báo');
      return;
    }
    let commentConfig = {
      target_link: this.comment.target_link,
      type: 'COMMENT_POST',
      name_campain: this.name_campain,
      accountJoinCampain: this.accountJoinCampain,
      configs: [
        {
          type: 'COMMENT_POST',
          contents: this.comments.split('\n'),
          time_before_seeding: "" + this.comment.time_before_seeding_from + "-" + this.comment.time_before_seeding_to,
          time_after_content: "" + this.comment.time_after_content_from + "-" + this.comment.time_after_content_to,
          time_after_seeding: "" + this.comment.time_after_seeding_from + "-" + this.comment.time_after_seeding_to
        }
      ]
    }
    commentConfig['typeAccount'] = groupAccounts;
    this.autoseedingService.create(commentConfig, runOrCreate).subscribe(response => {
      if (response.success) {
        // this.resetForm();
        this.toastrService.success('Tạo cấu hình thành công!', 'Thông báo');
      } else {
        this.toastrService.warning(response.msg, 'Thông báo');
      }
    },
      err => {
        this.toastrService.error('Có lỗi xảy ra!', 'Lỗi');
      });
  }
  createCommentCommentCampain(runOrCreate = 'CREATE') {
    let groupAccounts = this.groupAccountSelected.map(a => a.value);
    if (
      !this.checkAccountJoinCampain() ||
      !this.name_campain ||
      !this.comments ||
      !this.checkTimeDelay(this.replyComment.time_before_seeding_from, this.replyComment.time_before_seeding_to) ||
      !this.checkTimeDelay(this.replyComment.time_after_content_from, this.replyComment.time_after_content_to) ||
      !this.checkTimeDelay(this.replyComment.time_after_seeding_from, this.replyComment.time_after_seeding_to) ||
      !this.checkLinkFacebook(this.replyComment.target_link)
    ) {
      this.toastrService.warning('Vui lòng điền chính xác các thông tin của chiến dịch', 'Thông báo');
      return;
    }
    let commentConfig = {
      target_link: this.replyComment.target_link,
      type: 'COMMENT_COMMENT',
      name_campain: this.name_campain,
      accountJoinCampain: this.accountJoinCampain,
      configs: [
        {
          type: 'COMMENT_COMMENT',
          contents: this.comments.split('\n'),
          time_before_seeding: "" + this.comment.time_before_seeding_from + "-" + this.comment.time_before_seeding_to,
          time_after_content: "" + this.comment.time_after_content_from + "-" + this.comment.time_after_content_to,
          time_after_seeding: "" + this.comment.time_after_seeding_from + "-" + this.comment.time_after_seeding_to
        }
      ]
    }
    commentConfig['typeAccount'] = groupAccounts;
    this.autoseedingService.create(commentConfig, runOrCreate).subscribe(response => {
      if (response.success) {
        this.resetForm();
        this.toastrService.success('Tạo cấu hình thành công!', 'Thông báo');
      } else {
        this.toastrService.warning(response.msg, 'Thông báo');
      }
    },
      err => {
        this.toastrService.error('Có lỗi xảy ra!', 'Lỗi');
      });
  }

  createPostCampain(runOrCreate = 'CREATE') {
    let groupAccounts = this.groupAccountSelected.map(a => a.value);
    if (
      !this.checkAccountJoinCampain() ||
      !this.name_campain ||
      !this.post.content ||
      !this.checkTimeDelay(this.post.time_before_seeding_from, this.post.time_before_seeding_to) ||
      !this.checkTimeDelay(this.post.time_after_content_from, this.post.time_after_content_to) ||
      !this.checkTimeDelay(this.post.time_after_seeding_from, this.post.time_after_seeding_to) ||
      !this.checkGroupList() ||
      !this.checkMaxGroup(this.post.max_group)
    ) {
      this.toastrService.warning('Vui lòng điền chính xác các thông tin của chiến dịch', 'Thông báo');
      return;
    }
    let postConfig = {
      type: 'POST',
      accountJoinCampain: this.accountJoinCampain,
      name_campain: this.name_campain,
      configs: [
        {
          type: 'POST',
          content: this.post.content,
          is_post_personal: this.post.is_post_personal,
          maxPostGroup: this.post.max_group,
          groups: this.groups ? this.groups.split('\n'): [],
          time_before_seeding: "" + this.post.time_before_seeding_from + "-" + this.post.time_before_seeding_to,
          time_after_content: "" + this.post.time_after_content_from + "-" + this.post.time_after_content_to,
          time_after_seeding: "" + this.post.time_after_seeding_from + "-" + this.post.time_after_seeding_to
        }
      ]
    }
    postConfig['typeAccount'] = groupAccounts;
    this.autoseedingService.create(postConfig, runOrCreate).subscribe(response => {
      if (response.success) {
        this.resetForm();
        this.toastrService.success('Tạo cấu hình thành công!', 'Thông báo');
      } else {
        this.toastrService.warning(response.msg, 'Thông báo');
      }
    },
      err => {
        this.toastrService.error('Có lỗi xảy ra!', 'Lỗi');
      });
  }
  createSeedingPostCampain(runOrCreate = 'CREATE') {
    let groupAccounts = this.groupAccountSelected.map(a => a.value);
    let reactions = [];
    for (var _key in this.reaction) {
      if (this.reaction[_key]) {
        reactions.push({
          vi: this.translate[_key],
          en: _key
        });
      }
    }

    if (!this.checkLinkFacebook(this.seeding_post.target_link)) {
      this.toastrService.warning('Vui lòng kiểm tra link bài viết cần seeding', 'Thông báo');
      return;
    }
    if (this.seeding_post.isLike) {
      if (
        !(reactions.length == 1) ||
        !this.checkAccountJoinCampain() ||
        !this.name_campain ||
        !this.checkTimeDelay(this.seeding_post.time_before_like_from, this.seeding_post.time_before_like_to) ||
        !this.checkTimeDelay(this.seeding_post.time_after_like_from, this.seeding_post.time_after_like_to)
      ) {
        this.toastrService.warning('Vui lòng điền chính xác các thông tin của chiến dịch', 'Thông báo');
        return;
      }
    }

    if (this.seeding_post.isComment) {
      if (
        !this.comments ||
        !this.checkAccountJoinCampain() ||
        !this.name_campain ||
        !this.checkTimeDelay(this.seeding_post.time_before_comment_from, this.seeding_post.time_before_comment_to) ||
        !this.checkTimeDelay(this.seeding_post.time_after_content_comment_from, this.seeding_post.time_after_content_comment_to) ||
        !this.checkTimeDelay(this.seeding_post.time_after_comment_from, this.seeding_post.time_after_comment_to)
      ) {
        this.toastrService.warning('Vui lòng điền chính xác các thông tin của chiến dịch', 'Thông báo');
        return;
      }
    }

    let seeding_post_config = {
      type: 'DYNAMIC_SCRIPT',
      type_dynamic_scripts: 'SEEDING_POST',
      target_link: this.seeding_post.target_link,
      accountJoinCampain: this.accountJoinCampain,
      name_campain: this.name_campain,
      configs: []
    }
    seeding_post_config['typeAccount'] = groupAccounts;

    if (this.seeding_post.isLike) {
      seeding_post_config.configs.push({
        type: 'LIKE_POST',
        reaction: reactions,
        time_before_seeding: `${this.seeding_post.time_before_like_from}-${this.seeding_post.time_before_like_to}`,
        time_after_seeding: `${this.seeding_post.time_after_like_from}-${this.seeding_post.time_after_like_to}`
      })
    }
    if (this.seeding_post.isComment) {
      seeding_post_config.configs.push({
        type: 'COMMENT_POST',
        contents: this.comments.split('\n'),
        time_before_seeding: "" + this.seeding_post.time_before_comment_from + "-" + this.seeding_post.time_before_comment_to,
        time_after_content: "" + this.seeding_post.time_after_content_comment_from + "-" + this.seeding_post.time_after_content_comment_to,
        time_after_seeding: "" + this.seeding_post.time_after_comment_from + "-" + this.seeding_post.time_after_comment_to
      })
    }
    if (this.seeding_post.isShare) {
      seeding_post_config.configs.push(
        {
          type: "SHARE",
          is_share_personal: this.seeding_post.is_share_personal,
          content: this.seeding_post.content_share,
          groups: this.groups ? this.groups.split('\n'): [],
          maxShareGroup: this.seeding_post.max_group,
          time_before_seeding: "" + this.seeding_post.time_before_share_from + "-" + this.seeding_post.time_before_share_to,
          time_after_content: "" + this.seeding_post.time_after_content_share_from + "-" + this.seeding_post.time_after_content_share_to,
          time_after_seeding: "" + this.seeding_post.time_after_share_from + "-" + this.seeding_post.time_after_share_to
        }
      )
    }
    if (seeding_post_config.configs.length == 0) {
      this.toastrService.warning('Vui lòng chọn 1 action seeding', 'Thông báo');
    }

    this.autoseedingService.create(seeding_post_config, runOrCreate).subscribe(response => {
      if (response.success) {
        this.resetForm();
        this.toastrService.success('Tạo cấu hình thành công!', 'Thông báo');
      } else {
        this.toastrService.warning(response.msg, 'Thông báo');
      }
    },
      err => {
        this.toastrService.error('Có lỗi xảy ra!', 'Lỗi');
      });
  }
  createSeedingInteractiveCampain(runOrCreate = 'CREATE') {
    let groupAccounts = this.groupAccountSelected.map(a => a.value);

    // đăng bài
    if (this.interactive.is_post) {
      if (
        !this.checkAccountJoinCampain() ||
        !this.name_campain ||
        !this.interactive.content_post ||
        !this.checkTimeDelay(this.interactive.time_before_post_from, this.interactive.time_before_post_to) ||
        !this.checkTimeDelay(this.interactive.time_after_content_post_from, this.interactive.time_after_content_post_to) ||
        !this.checkTimeDelay(this.interactive.time_after_post_from, this.interactive.time_after_post_to) ||
        !this.checkGroupList() ||
        !this.checkMaxGroup(this.interactive.max_group)
      ) {
        this.toastrService.warning('Vui lòng điền chính xác các thông tin của chiến dịch đăng bài', 'Thông báo');
        return;
      }
    }

    if (this.interactive.is_join_group) {
      if (
        !this.checkAccountJoinCampain() ||
        !this.name_campain ||
        !this.checkTimeDelay(this.interactive.time_before_join_from, this.interactive.time_before_join_to) ||
        !this.checkTimeDelay(this.interactive.time_after_join_from, this.interactive.time_after_join_to) ||
        !this.checkTimeDelay(this.interactive.time_after_join_from, this.interactive.time_after_join_to) ||
        !this.checkGroupList2() ||
        !this.checkMaxGroup(this.interactive.max_group)
      ) {
        this.toastrService.warning('Vui lòng điền chính xác các thông tin của chiến dịch', 'Thông báo');
        return;
      }
    }

    let interactive_config = {
      type: 'DYNAMIC_SCRIPT',
      type_dynamic_scripts: 'INTERACTIVE',
      name_campain: this.name_campain,
      accountJoinCampain: this.accountJoinCampain,
      configs: []
    }
    interactive_config['typeAccount'] = groupAccounts;

    if (this.interactive.is_post) {
      interactive_config.configs.push({
        type: 'POST',
        content: this.interactive.content_post,
        is_post_personal: this.interactive.is_post_personal,
        maxPostGroup: this.interactive.max_group,
        groups: this.groups ? this.groups.split('\n'): [],
        time_before_seeding: "" + this.interactive.time_before_post_from + "-" + this.interactive.time_before_post_to,
        time_after_content: "" + this.interactive.time_after_content_post_from + "-" + this.interactive.time_after_content_post_to,
        time_after_seeding: "" + this.interactive.time_after_post_from + "-" + this.interactive.time_after_post_to
      })
    }
    if (this.interactive.is_join_group) {
      interactive_config.configs.push({
        max_group: this.join_group.max_group,
        type: "JOIN_GROUP",
        groups: this.groups2.split('\n'),
        content_replys: this.answers_join_group.split('\n'),
        is_join_1_group: this.interactive.is_join_1_group,
        time_before_seeding: "" + this.interactive.time_before_join_from + "-" + this.interactive.time_before_join_to,
        time_after_content: "" + this.interactive.time_after_content_join_from + "-" + this.interactive.time_after_content_join_to,
        time_after_seeding: "" + this.interactive.time_after_join_from + "-" + this.interactive.time_after_join_to
      })
    }
    if (interactive_config.configs.length == 0) {
      this.toastrService.warning('Vui lòng chọn 1 action seeding', 'Thông báo');
    }

    this.autoseedingService.create(interactive_config, runOrCreate).subscribe(response => {
      if (response.success) {
        this.resetForm();
        this.toastrService.success('Tạo cấu hình thành công!', 'Thông báo');
      } else {
        this.toastrService.warning(response.msg, 'Thông báo');
      }
    },
      err => {
        this.toastrService.error('Có lỗi xảy ra!', 'Lỗi');
      });
  }


  runOrCreate(type) {
    if (this.actionSeedingSelected[0].id == 'LIKE_PAGE') {
      this.createLikePageCampain(type);
    }
    if (this.actionSeedingSelected[0].id == 'FOLLOW_USER') {
      this.createFollowUserCampain(type);
    }
    if (this.actionSeedingSelected[0].id == 'LIKE_POST') {
      this.createLikeCampain(type);
    }
    if (this.actionSeedingSelected[0].id == 'LIKE_COMMENT') {
      this.createLikeCommentCampain(type);
    }
    if (this.actionSeedingSelected[0].id == 'COMMENT_POST') {
      this.createCommentPostCampain(type);
    }

    if (this.actionSeedingSelected[0].id == 'COMMENT_COMMENT') {
      this.createCommentCommentCampain(type);
    }
    if (this.actionSeedingSelected[0].id == 'POST') {
      this.createPostCampain(type);
    }
    if (this.actionSeedingSelected[0].id == 'JOIN_GROUP') {
      this.createJoinGroupCampain(type);
    }
    if (this.actionSeedingSelected[0].id == 'SHARE') {
      this.createShareCampain(type);
    }
    if (this.actionSeedingSelected[0].id == 'DYNAMIC_SCRIPT' && this.dynamicScriptSelected[0].id == 'POST') {
      this.createSeedingPostCampain(type);
    }
    if (this.actionSeedingSelected[0].id == 'DYNAMIC_SCRIPT' && this.dynamicScriptSelected[0].id == 'VIA') {
      this.createSeedingInteractiveCampain(type);
    }
  }

  resetForm() {
    this.reaction.Like = false;
    this.reaction.Love = false;
    this.reaction.Care = false;
    this.reaction.Haha = false;
    this.reaction.Wow = false;
    this.reaction.Sad = false;
    this.reaction.Angry = false;
    this.groups = '';
    this.comments = '';
    this.answers_join_group = '';

    this.like = new Like();
    this.likeComment = new LikeComment();
    this.likePage = new LikePage();
    this.followUser = new FollowUser();
    this.share = new Share();
    this.seeding_comment = new SeedingComment();
    this.seeding_post = new SeedingPost();

    this.comment = new Comment();
    this.replyComment = new Comment();
    this.post = new Post();
    this.join_group = new JoinGroup();
    this.interactive = new Interactive();
    this.accountJoinCampain = 1;

    this.currentRunning = null;
    this.check_name_campain = false;
    this.name_campain = '';
    this.groupAccountSelected = [];
  }

  onItemSelect(item: any) {
    this.resetForm();
  }

  OnItemDeSelect(item: any) {
    this.resetForm();
  }

  onSelectAll(items: any) {
  }

  onDeSelectAll(items: any) {
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/auto-seeding/auto-seeding.component.ts